(() => {
  if (window.offsurePrivacyControlsInstalled) return;
  window.offsurePrivacyControlsInstalled = true;
  let bannerLoad;
  function loadBanner() {
    if (window.privacyBanner?.showPreferences) return Promise.resolve();
    if (!bannerLoad) {
      bannerLoad = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        const timeout = window.setTimeout(() => reject(new Error('Preferences unavailable')), 10000);
        script.onload = () => { window.clearTimeout(timeout); resolve(); };
        script.onerror = () => { window.clearTimeout(timeout); reject(new Error('Preferences unavailable')); };
        document.head.append(script);
      }).catch(error => { bannerLoad = undefined; throw error; });
    }
    return bannerLoad;
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-offsure-privacy-open]');
    if (!button || button.disabled) return;
    const errorMessage = button.parentElement.querySelector('.offsure-privacy-error');
    errorMessage.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await loadBanner();
      await window.privacyBanner.showPreferences();
      // A store with no configured native banner can resolve without opening UI.
      // Do not leave visitors with a button that appears to do nothing.
      await new Promise((resolve, reject) => {
        const started = Date.now();
        const check = () => {
          const dialog = document.getElementById('shopify-pc__prefs__dialog');
          if (dialog?.getClientRects().length) return resolve();
          if (Date.now() - started > 3000) return reject(new Error('Preferences unavailable'));
          window.setTimeout(check, 100);
        };
        check();
      });
    } catch {
      errorMessage.hidden = false;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
